export enum CHANNEL_SOURCE {
  BINANCE = 'QfjGf',
  GATEIO = 'LkTBz',
  DESKTOP = 'fXQKP',
  MOBILE = 'ukRCD',
  KUCOIN = 'Kc6n7',
  BYBIT = 'B720n',
  KingTwitter = 'ktxer',
  KingGoogleAds = 'kngds',
  KingFacebook = 'knfcb'
}

export interface ChannelSourceHeader {
  [name: string]: CHANNEL_SOURCE;
}

export const CHANNEL_MAP: Record<
  string,
  { slug: CHANNEL_SOURCE; medium: string }
> = {
  twitter: { slug: CHANNEL_SOURCE.KingTwitter, medium: 'social' },
  google: { slug: CHANNEL_SOURCE.KingGoogleAds, medium: 'cpc' },
  facebook: { slug: CHANNEL_SOURCE.KingFacebook, medium: 'social' }
};
